module.exports = __webpack_public_path__ + "img/icon-divider.d0d5e966.svg";